import type { ReactNode } from "react";

export default function SmartMapDock({ id, label, open, onToggle, children }: {
  id: string; label: string; open: boolean; onToggle: () => void; children: ReactNode;
}) {
  return <aside className="smart-map-dock" aria-label={`${label} panel`}>
    <button type="button" className="smart-map-dock-tab" aria-label={label}
      aria-expanded={open} aria-controls={id} onClick={onToggle}>
      <i className={`pi ${open ? "pi-angle-right" : "pi-angle-left"}`} aria-hidden="true" />
      <span>{label}</span>
    </button>
    <div id={id} className="smart-map-dock-content" hidden={!open}>{children}</div>
  </aside>;
}
